export class TypeStampRubric {
  public static readonly ORIGINAL = true;
  public static readonly COPY = false;
}
